import icon236ko from "./Images/236ko.png";
import iconMeleeVS from "./Images/meleevs.png";
import iconLostInTransl8tion from "./Images/lostintransl8tion.png";
import iconLegl from "./Images/legl.png";

// videos are copied from each YouTube playlist (playlist order)
const projects = [
  {
    title: "236KO",
    icon: icon236ko,
    tagline: "Motion inputs for games without them",
    description:
      "A motion input reader for Windows that turns fighting-game motions like 236 into simple controls, so games without them (like 2XKO) get motion inputs.",
    tech: "C#",
    href: "https://github.com/Joyastick/236KO",
    playlist: "https://www.youtube.com/playlist?list=PLPDRZtF0aIyY",
    videos: ["K7MCOvHyUjs", "0V--PiLHa2A"],
  },
  {
    title: "MeleeVS",
    icon: iconMeleeVS,
    tagline: "2v2 tag mode for Melee on PC",
    description:
      "A 2v2 tag fighter mod for the native PC port of Super Smash Bros. Melee. Call in a partner mid-match, solo with a CPU assist or as a duo.",
    tech: "C",
    href: "https://github.com/Joyastick/melee-pc-TagFighter",
    playlist: "https://www.youtube.com/playlist?list=PLPJflWq8htNI",
    videos: ["gs7NT7d6fQ8", "4M-AVMv4iKc", "-yvMZW_ZGjE", "lbSgGi55RVY"],
  },
  {
    title: "Legl.js",
    featured: false, // projects page only, not the home page tiles
    icon: iconLegl,
    tagline: "A phone remote for the League client",
    description:
      "Control the League of Legends client from your phone: queue, accept, ban and pick in champ select, and chat with your party. End-to-end encrypted through a relay, with notifications when a match is found.",
    tech: "JavaScript",
    // the repo is private, so the link goes to the site
    href: "https://legl.joyastick.com",
    linkText: "Visit legl.joyastick.com",
  },
  {
    title: "Lost In Transl8tion - Japan",
    featured: false, // projects page only, not the home page tiles
    icon: iconLostInTransl8tion,
    description: "A vlog series with my friends from my trip to Japan.",
    playlist: "https://www.youtube.com/playlist?list=PL7Ztb1P9LqG2P6Nfs9Ak0jZ5IFLzOoCJ9",
    videos: [
      "VOyNi9BO6TI", "g07kEsPMpPc", "NfSt-SyuiwY", "kU7_V14Y5xA",
      "xgEx2F9Ys1A", "HUMSn0dEcCA", "c6-RHTMRZ54", "5eeL03mZ1sA",
    ],
  },
];

export default projects;
